import {CLEANING_PLAN_ERROR} from "../../reducers/cleaningPlanReducer";

export const getCleaningPlanError = (error) =>{
    return {
        type: CLEANING_PLAN_ERROR,
        payload: {error}
    }
}